import { makeStyles } from '@material-ui/core';

export const useDrawerStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: (props) => ({
    width: props.drawerWidth,
    flexShrink: 0,
  }),
  drawerPaper: (props) => ({
    width: props.drawerWidth,
    backgroundColor: props.backgroundColor ? props.backgroundColor : 'default',
  }),
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
  },
}));
